import React from "react";
import { useNavigate } from "react-router";
import { ActionsContainer } from "../styled/feedWrite";

const Actions = ({ feed, closeModal, handleSubmit, openModal, setActive }) => {
  const navigate = useNavigate();
  const exitWrite = () => {
    if (setActive) {
      setActive(0);
      closeModal();
    } else {
      navigate(-1);
    }
  };

  return (
    <ActionsContainer>
      <button
        onClick={() =>
          (Array.isArray(feed.imgUrl) && feed.imgUrl.length > 0) || feed.content
            ? openModal({
                isOpen: true,
                type: "confirmation",
                title: "작성 취소",
                message: [`작성을 취소하시겠습니까?`],
                handleConfirm: () => exitWrite(),
                handleCancel: () => closeModal(),
              })
            : exitWrite()
        }>
        취소
      </button>
      <button
        onClick={() =>
          openModal({
            isOpen: true,
            type: "confirmation",
            title: "피드 작성",
            message: [`피드를 작성하시겠습니까?`],
            handleConfirm: () => handleSubmit(),
            handleCancel: () => closeModal(),
          })
        }>
        등록
      </button>
    </ActionsContainer>
  );
};

export default Actions;
